module.exports = __webpack_public_path__ + "img/vignette-sets-tampons-alphabet.04f964ee.jpg";